const state = {
  // 数据导出查询参数
  dataExportParams: {
    dtMonth: '',
    hospIds: '',
    pageIndex: 1,
    pageSize: 10
  },
  dataExportList: [],
  dataExportListTotal: 0,
  dataExportDetailsParams: {
    hospId: '',
    hospName: '',
    dtMonth: '',
    isExport: false,
    pageIndex: 1,
    pageSize: 10
  }
}
const getters = {}
const mutations = {
  SET_DATA_EXPORT_LIST(state, res){
    state.dataExportList = res.list
    state.dataExportListTotal = res.total
  },
}
const actions = {
  dataExportListChange({ commit }, options) {
    commit('SET_DATA_EXPORT_LIST', options)
  }
}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}